import { useState, useEffect, useContext } from 'react'
import { Layout, Popover, Menu, Input, Button } from 'antd';
import { config } from "./config"
import { backendUrl } from "../../Config"
// import 'antd/dist/antd.min.css';
import "./sidebar.css"
import { ajaxFetchCall } from '../../services/ApiService';
import { UserContext } from '../context/UserContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { delay } from '../../services/Delay';
import { StarFilled, StarOutlined } from '@ant-design/icons';


const { SubMenu } = Menu;
const { Sider, Header, Content, Footer } = Layout;

const getChildren = (c) => {
    let children = []
    if (c.children) {
        for (let child of c.children) {
            children.push(<Menu.Item key={child.title}>
                <Link to={child.link}>
                    {child.title}
                </Link>
            </Menu.Item>)
        }
    }
    return children
}

const getSidebar = () => {
    let sidebar = []
    for (let c of config) {
        let k = null
        if (c.children) {
            k = <SubMenu key={c.title} title={c.title}>
                {getChildren(c)}
            </SubMenu>
        } else {
            k = <Menu.Item key={c.title}>
                <Link to={c.link}>
                    {c.title}
                </Link>
            </Menu.Item >
        }
        sidebar.push(k)
    }
    return sidebar
}


export default function Sidebar(props) {


    let [sidebarCollapsed, setSidebarCollapsed] = useState(true)
    let [isLogin, setIsLogin] = useState(false)
    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [favName, setFavName] = useState("")
    const [allFav, setAllFav] = useState([])


    useEffect(() => {
        getInfo()
        getAllFav()
    }, [user])

    const getAllFav = async () => {
        try {
            let allFav = await ajaxFetchCall(backendUrl + "/user/fav")
            setAllFav(allFav["response"].map((item) => item.url))
        } catch (err) {
            if (err.status == 401) {
                navigate("/login")
            }

        }

    }
    const getInfo = async () => {
        let data = await ajaxFetchCall(backendUrl + "/user/info")
        if (data["response"]["username"]) {
            setIsLogin(true)
        } else {
            setIsLogin(false)
        }
    }

    const toggle = () => {
        setSidebarCollapsed(!sidebarCollapsed)
    };
    const logout = async () => {
        let data = await ajaxFetchCall(backendUrl + "/user/logout")
        setIsLogin(false)
        setUser({})
        setTimeout(() => {
            navigate("/login")
        }, 10)

    }
    const login = () => {
        navigate("/login")
    }

    const addFav = async (e) => {
        let body = JSON.stringify({
            name: favName,
            url: (window.location.pathname + window.location.search).substr(1)

        });
        await ajaxFetchCall(backendUrl + "/user/fav", {
            method: "POST",
            body: body
        })
        setFavName("")
        getAllFav()

    }
    const updateName = (e) => {
        setFavName(e.target.value)
    }

    const content = () => {
        return <div>
            <Input value={favName} onChange={updateName} placeholder="Basic usage" />
            <Button onClick={addFav} type="primary">Submit</Button>
        </div>
    };

    const isUrlMatch = () => {
        return allFav.indexOf((window.location.pathname + window.location.search).substr(1)) == -1 ? false : true
    }

    return <Layout style={{ minHeight: '100vh' }}>
        {
            isLogin &&
            <Sider collapsedWidth={0} collapsible collapsed={sidebarCollapsed} onCollapse={toggle}>
                <Menu
                    mode="inline"
                >
                    {getSidebar()}
                </Menu>
            </Sider>
        }
        <Layout className="site-layout">
            <Header className="site-layout-background" style={{ padding: 0 }} >
                {isLogin &&
                    <div>
                        <div className="logout" onClick={logout}> Logout </div>
                        {isUrlMatch()
                            ?
                            <StarFilled className="start-icon" />
                            :
                            <Popover title="Bookmark" content={content} trigger="click">
                                <StarOutlined className="start-icon" />
                            </Popover>
                        }


                    </div>

                }
                {!isLogin && <div className="login" onClick={login}> Login </div>}
            </Header>
            <Content style={{ "marginLeft": "5px", "marginTop": '10px' }}>
                <div className="site-layout-background" style={{ padding: 3, minHeight: 360 }}>
                    {props.children}
                </div>
            </Content>
            {/* <Footer style={{ textAlign: 'center' }}>Lets rock the world</Footer> */}
        </Layout>
    </Layout>

}